import React, { useEffect, useState } from "react";
import Typography from '@material-ui/core/Typography';
import clsx from 'clsx';
import useStyles from './style';

const SelectOpportunityTypeViewer = (props) => {
  const { config, blockState, block} = props;
  const classes = useStyles();

  const [activeTab, setActiveTab] = useState("Standard");
  const [selectedCard, setSelectedCard] = useState(blockState);

  const isReadOnly = (block?.readOnly && !!props?.match?.params?.id) || false;


  console.log('isReadOnly*::', isReadOnly, block, props?.match?.params?.id)

  useEffect(() => {
    setSelectedCard(blockState);
  }, [blockState]);

  const generateId = (sentence) => {
    const prefix = sentence
      .split(" ")
      .map(word => word.charAt(0).toUpperCase())
      .join("");
    const randomNum = Math.floor(100000000 + Math.random() * 900000000);
    return `#${prefix}${randomNum}`;
  };

  const filteredCards =
    activeTab === "All"
      ? config.cards
      : config.cards.filter((c) => c.type.toLowerCase() === activeTab.toLowerCase());

  const handleCardClick = (card) => {
    if (isReadOnly) {
      return;
    }

    if (selectedCard && selectedCard[config.dataElement] === card[config.dataElement]) {
      setSelectedCard(null);
      props.onChangeOpportunityTypeViewer({
        removeKeys: [config.dataElement, "opportunityType"]
      });
    } else {
      let finalvalue = {};
      finalvalue[config.dataElement] = card[config.dataElement];
      finalvalue["opportunityType"] = card["type"];
      finalvalue["opportunityID"] = generateId(card[config.dataElement]);
      props.onChangeOpportunityTypeViewer(finalvalue);
      setSelectedCard(card);
      if (props.match?.params?.id && props.onEditModeChange) {
        props.onEditModeChange(true);
      }
    }
  };

  const handleTabClick = (tabLabel) => {
    // Prevent tab changes when in read-only mode
    if (isReadOnly) {
      return;
    }
    setActiveTab(tabLabel);
  };

  return (
    <div className={classes.root}>
      <div className={classes.colWrap}>
        {/* Tabs */}
        <div className={classes.tabsBar}>
          {config.tabs.map((tab) => {
            const isActive = activeTab === tab.label;
            return (
              <div
                key={tab.label}
                onClick={() => handleTabClick(tab.label)}
                className={clsx(classes.tab, isActive && classes.tabActive)}
              >
                <Typography className={clsx(classes.tabLabel, isActive && classes.tabLabelActive)}>
                  {tab.label}
                </Typography>
              </div>
            );
          })}
        </div>

        {/* Cards Grid */}
        <div className={clsx('myScrollContainer', classes.grid)}>
          {filteredCards && filteredCards.map((card, index) => {
            const isSelected = selectedCard && selectedCard[config.dataElement] === card[config.dataElement];
            return (
              <div
                key={index}
                className={clsx(classes.card, isSelected && classes.cardSelected)}
                onClick={() => handleCardClick(card)}
              >
                {isSelected && (
                  <div className={classes.cardTickCorner}>
                    <img src={"/media/createStepper/cardTick.svg"} className={classes.cardTickImg} alt="" />
                  </div>
                )}

                <div className={classes.iconCircle}>
                  <img src={card.icon} className={classes.iconImg} alt="" />
                </div>

                <div className={classes.textBlock}>
                  <Typography className={classes.cardTitle}>{card.title}</Typography>
                  <Typography className={classes.cardDesc}>{card.description}</Typography>
                </div>

                <div className={classes.highlightsWrap}>
                  {card.highlights.map((point, i) => (
                    <div key={i} className={classes.highlightRow}>
                      <img src={"/media/createStepper/uCheck.svg"} className={classes.highlightIcon} alt="" />
                      <Typography className={classes.highlightText}>{point}</Typography>
                    </div>
                  ))}
                </div>
              </div>
            );
          })}
        </div>
      </div>
      {/* {showValidationMessage()} */}
    </div>
  );
};

export default SelectOpportunityTypeViewer;
